import * as React from 'react';

import { mergeStyles, OutsideClick } from '@cian/components';
import { IconClose } from './close_icon';

const style = require('./index.css');

interface ITooltipPopup {
  // tslint:disable-next-line:no-any
  children: any;
  containerClass?: string;
  direction?: TDirection;
  handlePopupClose(): void;
  open: boolean;
}

type TDirection = 'left' | 'right';

export const TooltipPopup = (props: ITooltipPopup) => {
  const directionClass = props.direction === 'left' ? style['container--left'] : '';
  const containerStyles = mergeStyles([style['container'], directionClass, props.containerClass]);

  return props.open ? (
    <OutsideClick onOutsideClick={props.handlePopupClose}>
      <div {...containerStyles}>
        <div className={style['popup']}>
          <div className={style['close']} onClick={props.handlePopupClose}>
            <IconClose />
          </div>
          {props.children}
        </div>
      </div>
    </OutsideClick>
  ) : null;
};
